// extracted by mini-css-extract-plugin
export default {"techStackBlock":"Skills_techStackBlock__MSpFG","icons":"Skills_icons__EQux+","items":"Skills_items__tA6ty","topskillsBlock":"Skills_topskillsBlock__NomkB"};